import React from 'react'
import Spinner from '../../../../../partials/content/Spinner'

/**
 * Spinner in place of a tab's content while only that tab's data is loading.
 */
function LoadingTab() {
  return (
    <div className="modal-loading-centered">
      <Spinner />
    </div>
  )
}

export default React.memo(LoadingTab)
